<template>
  <div>
    <b-modal
      id="automarkingInfoModal"
      ref="automarkingInfoModal"
      :no-footer="true"
      ok-variant="secondary"
      size="md"
      @close="onHideModal"
      @hide="onHideModal"
    >
      <template #title>
        <i class="fa fa-info me-1"></i> {{ $t("How automarking works?") }}
      </template>

      <p>{{ $t("automarking_info_intro") }}</p>

      <p>
        <strong>{{
          $t(
            variant === "registration"
              ? "automarking_info_important_registration"
              : "automarking_info_important_edit",
          )
        }}</strong>
      </p>

      <p class="fw-bold mb-1">{{ $t("Where can I change or set up automatic ordering?") }}</p>

      <ol>
        <li>{{ $t("automarking_info_where_step_1") }}</li>
        <li>{{ $t("automarking_info_where_step_2") }}</li>
      </ol>

      <p class="fw-bold mb-1">{{ $t("Useful information") }}</p>

      <ul>
        <li>{{ $t("automarking_info_tip_1") }}</li>
        <li>{{ $t("automarking_info_tip_2") }}</li>
      </ul>

      <p v-if="!isOrderChargeTimeInOrderDay">
        <strong>{{ $t("WARNING!") }}</strong>
        {{ $t("The system will mark your presence only if you have funds on your account.") }}
      </p>
    </b-modal>
  </div>
</template>

<script>
import { isOrderChargeTimeInOrderDay } from "@/modules/settings/queries/tenantSettingsSelectors";

export default {
  name: "AutomarkingInfoModal",

  props: {
    show: {
      type: Boolean,
      default: false,
      required: true,
    },

    variant: {
      type: String,
      default: "edit",
      validator: (value) => ["registration", "edit"].includes(value),
    },
  },

  emits: ["hide"],

  setup() {
    return { isOrderChargeTimeInOrderDay };
  },

  watch: {
    show(newValue) {
      if (newValue) {
        this.$refs.automarkingInfoModal.show();
      }
    },
  },

  async mounted() {
    if (this.show) {
      await this.$nextTick();
      this.$refs.automarkingInfoModal.show();
    }
  },

  methods: {
    onHideModal() {
      this.$emit("hide");
    },
  },
};
</script>
